<template>
  <div>
    <div>
      <b-modal id="modal-logs" :title="this.rowUsedForDetails.name" okOnly>
        <p class="my-4">          
          {{ $t('monitoramento.resumo.tabs.log_panel.codigo_erro') }}
          <b>{{ this.rowUsedForDetails.app_code }}</b>
          <br/>
          <b class="text-danger">{{ this.rowUsedForDetails.error_message }}</b>
        </p>
      </b-modal>
    </div>

    <data-table
        :columns="datatable.columns"
        :datas="logslist"
        :styleClass="datatable.styleClass"
        :eventsHandler="datatable.eventsHandler"
        :tableMode="datatable.tableMode"
        :totalRecords="datatable.totalRecords"
        :service="datatable.service"
        :selectOptions="{
         enabled: false,
        }"
        @update-data="updateData"
        @update-total="updateTotalRecords"
        ref="LogsDataTable"
    />

  </div>
</template>

<script>
import $axios from '@/providers/AxiosServiceProvider'
import DataTable from '@/components/data-table'
import ModalComponent from '@/components/Modal'
import HttpStatus from 'http-status-codes'

export default {
  name: 'VnsLogPanel',
  components: {
    DataTable,
    ModalComponent
  },
  data() {
    return {
      pages: {},
      logslist: [],
      datatable: {
        styleClass: 'table table-bordered dataTable',
        service: 'vam/vns/erros',
        columns: [
          {
            label: this.$t('monitoramento.resumo.tabs.log_panel.vns_equipamento'),
            field: 'name',
            filterOptions: {
              enabled: false,
              placeholder: 'Vns'
            }
          },
          {
            customType: this.$t('monitoramento.resumo.tabs.log_panel.tipo'),
            label: 'Tipo',
            class: 'badge badge-danger',
            tdLabel: 'Erro',
            field: 'id'
          },
          {
            label: this.$t('monitoramento.resumo.tabs.log_panel.data_hora'),
            field: 'created_at',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX',
            dateOutputFormat: 'dd/MM/y HH:mm:ss'
          },
          {
            customType: 'Logs',
            label: this.$t('monitoramento.resumo.tabs.log_panel.acao'),
            class: 'btn btn-primary',
            callback: this.callback,
            tdLabel: this.$t('monitoramento.resumo.tabs.log_panel.ver_log'),
            icon: 'fas fa-search',
            field: 'acao'
          }
        ],
        tableMode: 'remote',
        eventsHandler: {
          onSelectRow: this.onSelectRow
        },
        totalRecords: 0
      },
      container_class: 'pagination',
      li_class: 'paginate_button',
      actives: 0,
      rowUsedForDetails: {},
      selectedRows: [],
      config: {
        timeout: 50000, // timeout 50 seconds
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
      showModal: false
    }
  },
  async mounted() {
    await this.$refs.LogsDataTable.loadItems()

    this.timer = await setInterval(
        async () => {
          await this.$refs.LogsDataTable.loadItems()
        },
        30000)
  },
  methods: {
    callback(row) {
      this.rowUsedForDetails = {}
      this.rowUsedForDetails = row
      this.$bvModal.show('modal-logs')
    },
    openListPage(page) {
      this.showLogs()
      this.editPage = false
      this.listPage = true
    },
    async showLogs() {
      try {
        let result = await $axios.get('vam/logs/errors')
        if (result.status === HttpStatus.OK) {
          this.datatable.totalRecords = result.data.total
          this.logslist = result.data.data
        }
      } catch (e) {
      }
    },
    clickPage(pageNum) {
      this.showLogs(pageNum)
    },
    onSelectRow(rows) {
      this.selectedRows = rows.selectedRows.filter(
          row => row.name !== undefined
      )
    },
    updateData(newData) {
      if (!newData.isPaginate) {
        this.filterNewLogsNotInNotifications(newData.data).map((log) => {
          const htmlNotification = '<div><div class="snotifyToast__title">' + this.$t('monitoramento.resumo.tabs.log_panel.alerta_vns') + '</div>' +
              '<div class="snotifyToast__body">' +
                this.$t('monitoramento.resumo.tabs.log_panel.codigo_erro') + ' ' + log.app_code + '<br /> <b class="text-danger">' + log.error_message + '</b>'
          '</div><span class="snotify-icon snotify-icon--warning"></span></div>'
          this.$snotify.warning(this.$t('monitoramento.resumo.tabs.log_panel.codigo_erro') + " " + log.app_code + '\\n' + log.error_message, this.$t('monitoramento.resumo.tabs.log_panel.alerta_vns'), {
            timeout: 5000,
            html: htmlNotification,
            id: log.id
          })
        })
      }
      this.logslist = newData.data
    },
    updateTotalRecords(newTotal) {
      this.datatable.totalRecords = newTotal
    },
    filterNewLogsNotInNotifications(newLogs) {
      if (this.logslist.length === 0) {
        return [];
      }
      const Logs = newLogs.filter(newLog => !this.logslist.some(log => log.id === newLog.id));
      return Logs.filter(L => !this.$snotify.notifications.some(n => n.id === L.id))
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style>
</style>
